import { REALMS } from 'ciam-self-service-shared';

const getPageMetadataKey = (baseKey, type, realm) => {
  const isCustomer = realm === REALMS.CUSTOMER;

  if (isCustomer) {
    return `${baseKey}.customer.${type}`;
  }

  return `${baseKey}.${type}`;
};

const getPageMetadataKeys = (baseKey, realm) => {
  return {
    titleKey: getPageMetadataKey(baseKey, 'title', realm),
    descriptionKey: getPageMetadataKey(baseKey, 'meta.description', realm),
  };
};

/**
 * Utility function to get page metadata (title and description) with proper realm handling
 *
 * @param {string} baseKey - The base translation key (e.g., 'signin.page')
 * @param {Object} richIntl - The richIntl object from useRichIntl hook
 * @param {string} realm - The current realm (from useRealm hook)
 * @param {Object} values - Additional values to pass to formatMessage (e.g., { realm: 'Advisor Portal' })
 * @returns {Object} Object containing title and description strings
 *
 */
export const getPageMetadata = (baseKey, richIntl, realm, values = {}) => {
  const { titleKey, descriptionKey } = getPageMetadataKeys(baseKey, realm);

  return {
    title: richIntl.formatMessage({ id: titleKey }, values),
    description: richIntl.formatMessage({ id: descriptionKey }, values),
  };
};
